import { Provider } from 'react-redux';
import './App.css';
import { store } from './store/store';
import { Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PinLoginPage from './components/pages/auth/PinLoginPage';
import RequiredAuth from './components/pages/auth/RequiredAuth';
import ChangeAccessCodePage from './components/pages/auth/ChangeAccessCodePage';
import DashboardPage from './components/pages/DashboardPage';
import SharePage from './components/pages/share/SharePage';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';

// Services are initialized once in ./services/index.ts to avoid
// circular-dependency issues between HTTP services and AuthService.
export { authService, httpService } from './services';

export default function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider>
          <LanguageProvider>
            <Routes>
              <Route path="/" element={<RootPage />}>
                <Route path="/login" element={<PinLoginPage />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route path="/share/:token" element={<SharePage />} />
                <Route element={<RequiredAuth />}>
                  <Route index element={<DashboardPage />} />
                  <Route path="/change-access-code" element={<ChangeAccessCodePage mode="forced" />} />
                </Route>
              </Route>
            </Routes>
          </LanguageProvider>
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  );
}

export function sleep(n: number = 500) {
  return new Promise((r) => setTimeout(r, n));
}

export function Fallback() {
  return <p>Performing initial data load</p>;
}

export function RootPage() {
  return <Outlet />;
}

function LogoutPage() {
  return <div>Logging out...</div>;
}
